var styles = {
  "Listbox": "Polaris-Combobox__Listbox"
};

export { styles as default };
